/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const BusinessReportStatusDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the BusinessReportStatusDTO interface.
 */
export function instanceOfBusinessReportStatusDTO(value) {
    return true;
}
export function BusinessReportStatusDTOFromJSON(json) {
    return BusinessReportStatusDTOFromJSONTyped(json, false);
}
export function BusinessReportStatusDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'status': json['status'] == null ? undefined : json['status'],
        'ready': json['ready'] == null ? undefined : json['ready'],
        'inProgress': json['inProgress'] == null ? undefined : json['inProgress'],
        'windowDays': json['windowDays'] == null ? undefined : json['windowDays'],
        'periodStart': json['periodStart'] == null ? undefined : (new Date(json['periodStart'])),
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
        'readyAt': json['readyAt'] == null ? undefined : (new Date(json['readyAt'])),
        'reportRowCount': json['reportRowCount'] == null ? undefined : json['reportRowCount'],
        'unmatchedReportRows': json['unmatchedReportRows'] == null ? undefined : json['unmatchedReportRows'],
        'inventoryCount': json['inventoryCount'] == null ? undefined : json['inventoryCount'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}
export function BusinessReportStatusDTOToJSON(json) {
    return BusinessReportStatusDTOToJSONTyped(json, false);
}
export function BusinessReportStatusDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'status': value['status'],
        'ready': value['ready'],
        'inProgress': value['inProgress'],
        'windowDays': value['windowDays'],
        'periodStart': value['periodStart'] == null ? undefined : ((value['periodStart']).toISOString().substring(0, 10)),
        'periodEnd': value['periodEnd'] == null ? undefined : ((value['periodEnd']).toISOString().substring(0, 10)),
        'readyAt': value['readyAt'] == null ? undefined : ((value['readyAt']).toISOString()),
        'reportRowCount': value['reportRowCount'],
        'unmatchedReportRows': value['unmatchedReportRows'],
        'inventoryCount': value['inventoryCount'],
        'errorCode': value['errorCode'],
        'errorMessage': value['errorMessage'],
    };
}
